module.exports = __webpack_public_path__ + "img/error.5c38b482.jpg";